// extracted by mini-css-extract-plugin
export var innerStyle = "case_study_hero_inner-module--innerStyle--6Lso1";
export var wrapperStyle = "case_study_hero_inner-module--wrapperStyle--8FspU";